import styled, { keyframes, css } from 'styled-components';
import { Loader } from '../../../loader/index.js';
import { themeGet } from '../../foundation/theme/themeGet/get.js';
import { pxToRem } from '../../foundation/spacing/utils.js';

var fadeOut = keyframes(["0%{opacity:1;}100%{opacity:0;display:none;pointer-events:none;}"]);
var fadeOutStyles = css(["animation:", " 0.2s ease-in-out forwards;"], fadeOut);
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-mwi5jn-0"
})(["position:relative;width:", ";height:", ";"], function (_ref) {
  var $width = _ref.$width;
  return $width;
}, function (_ref2) {
  var $height = _ref2.$height;
  return $height;
});
var Overlay = styled.div.withConfig({
  displayName: "Overlay",
  componentId: "sc-mwi5jn-1"
})(["position:absolute;top:0;left:0;width:100%;height:100%;background-color:", ";", ";"], function (_ref3) {
  var $transparent = _ref3.$transparent;
  return $transparent ? css(["", "70"], themeGet('colors.gray.50')) : themeGet('colors.background.50');
}, function (_ref4) {
  var $enabled = _ref4.$enabled;
  return !$enabled && fadeOutStyles;
});
var LoaderContainer = styled.div.withConfig({
  displayName: "LoaderContainer",
  componentId: "sc-mwi5jn-2"
})(["position:absolute;top:0;left:0;width:100%;height:100%;display:flex;flex-direction:column;justify-content:", ";align-items:center;", ";"], function (_ref5) {
  var $position = _ref5.$position;
  return $position === 'center' ? 'center' : 'flex-start';
}, function (_ref6) {
  var $enabled = _ref6.$enabled;
  return !$enabled && fadeOutStyles;
});
var ContentContainer = styled.div.withConfig({
  displayName: "ContentContainer",
  componentId: "sc-mwi5jn-3"
})(["width:100%;height:100%;", ";transition:filter 0.2s ease-in-out;"], function (_ref7) {
  var $transparent = _ref7.$transparent,
    $enabled = _ref7.$enabled;
  return $enabled && $transparent && "filter: blur(" + pxToRem(1) + ");";
});
var StyledLoader = styled(Loader).withConfig({
  displayName: "StyledLoader",
  componentId: "sc-mwi5jn-4"
})(["", ";"], function (_ref8) {
  var $position = _ref8.$position;
  return $position === 'top' && "margin-top: " + themeGet('spacing.xl');
});

export { Container, ContentContainer, LoaderContainer, Overlay, StyledLoader };
